import script from "./ProductsMapComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsMapComponent.vue?vue&type=script&setup=true&lang=js"

import "./ProductsMapComponent.vue?vue&type=style&index=0&id=012841e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-012841e2"]])

export default __exports__